import { memo } from 'react'
import Head from 'next/head'
import { useTranslation } from 'react-i18next'
import selectorSettings from '../store/selectors/settings'

const HeaderTitle = memo((props) => {
    const { t } = useTranslation()

    const chunks = []

    const title =
        typeof props.children == 'object'
            ? props.children.join('')
            : props.children
    const env = selectorSettings.getEnv()

    if (env == 'dev') {
        chunks.push('[DEV]')
    }
    if (env == 'stg') {
        chunks.push('[STG]')
    }
    chunks.push(title)
    chunks.push(t('meta_title_suffix'))

    return (
        <Head>
            <title>{chunks.join(' | ')}</title>
        </Head>
    )
})

export default HeaderTitle
